import { Dropdown } from '@deere/ux.uxframe-react';
import React from 'react';
import {useUserInfo} from '../providers/userProvider'
import { useOktaAuth } from '@okta/okta-react'

export default function UserDropdown() {
    const userInfo = useUserInfo();
    const { oktaAuth } = useOktaAuth();
    const logout = async () => oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });

    return (
        <Dropdown alignRight={true}>
            <Dropdown.Toggle
                aria-label='account menu'
                size='sm'
                variant='link'
            >
                {'Hi,'} <span className='uxf-header-title-username'>{userInfo ? userInfo.given_name : ''}</span>{' '}
            </Dropdown.Toggle>
            <Dropdown.Menu> 
                <Dropdown.Item href="#" onClick={logout}>{'Sign out'}</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}